import React from 'react';
import '../../styles/LoaderOverlay.css'

type LoaderOverlayProps = {
  show: boolean;
  size?: number; // dot size in px
  color?: string; // dot color
};

const LoaderOverlay: React.FC<LoaderOverlayProps> = ({
  show,
  size = 16,
  color = 'white',
}) => {
  if (!show) return null;

  return (
    <div className="loader-backdrop">
      <div className="typing-loader">
        <span
          className="typing-dot"
          style={{ width: size, height: size, backgroundColor: color }}
        />
        <span
          className="typing-dot"
          style={{ width: size, height: size, backgroundColor: color }}
        />
        <span
          className="typing-dot"
          style={{ width: size, height: size, backgroundColor: color }}
        />
      </div>
    </div>
  );
};

export default LoaderOverlay;
